// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__1AQsY","container":"LayoutSideNavigation_container__1xUhh","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__1-IfB"};